import React from "react";
import PropTypes from "prop-types";

export const LinkedIn = ({ color = "#0077B5" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.43993 5.64538C7.43993 6.54238 6.75694 7.2683 5.68886 7.2683C4.66239 7.2683 3.9794 6.54238 4.00054 5.64538C3.9794 4.70478 4.66238 4 5.70932 4C6.75692 4 7.41946 4.70478 7.43993 5.64538ZM4.08641 18.9987V8.55039H7.33358V18.998H4.08641V18.9987Z" fill="#242424"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.93652 11.8859C9.93652 10.5827 9.89358 9.47164 9.85065 8.55284H12.6711L12.821 9.98422H12.8851C13.3125 9.32171 14.3806 8.31836 16.1112 8.31836C18.2473 8.31836 19.8498 9.72859 19.8498 12.804V19.0011H16.6026V13.2109C16.6026 11.8641 16.133 10.9459 14.9579 10.9459C14.0602 10.9459 13.5265 11.5655 13.3132 12.1633C13.2273 12.3773 13.185 12.6759 13.185 12.9758V19.0011H9.93783V11.8859H9.93652Z" fill="#242424"/>
</svg>

  );
};
LinkedIn.propTypes = {
  color: PropTypes.string,
};
